export const CV_PRODUCT_EVENT_NAME = 'cv-product-click';

export const CV_PRODUCT_EVENT_GROUP = {
  HERO_BANNER: 'hero-banner',
  SERVICE: 'service',
};
